import React, { useState, useEffect } from 'react';
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Button,
  List,
  Divider,
  Select,
  MenuItem,
  Tabs,
  Tab
} from '@mui/material';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import Navbar from '../../../Navbar'

import SessionItem from '../../../components/Sessions/SessionItem';

import MaterialForm from './MaterialForm'
import ActivitiesForm from './ActivitiesForm'

import { supabase } from '../../../supabaseClient'

// Import all the Font Awesome icons from the react-icons/fa module
import * as icons from 'react-icons/fa';

const iconOptions = Object.entries(icons).map(([key, Icon]) => ({
  icon: <Icon size={'32px'} />,
  label: key,
}));

const SessionForm = ({ onSessionAdd, onSessionUpdate, onSessionDelete, sessions }) => {
  const [name, setName] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [date_from, setDateFrom] = useState('');
  //const [date_to, setDateTo] = useState('');
  const [icon, setIcon] = useState(null);
  const [location, setLocation] = useState('');
  const [latitude, setLatitude] = useState(-33.442840627318205);
  const [longitude, setLongitude] = useState(-70.65470762839571);
  const [selectedSession, setSelectedSession] = useState(null);
  const [mode, setMode] = useState('create');

  const [materials, setMaterials] = useState([]); // pdfs,etc
  const [activities, setActivities] = useState([])


  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);

  const [selectedTab, setSelectedTab] = useState('materials');

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleSubtitleChange = (e) => {
    setSubtitle(e.target.value);
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  /*const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };*/

  const handleIconChange = (selectedIcon) => {
    setIcon(selectedIcon);
    console.log(selectedIcon)
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };

  const handleSessionSubmit = (e) => {
    e.preventDefault();
    if (mode === 'create') {
      const session = {
        name: name,
        subtitle: subtitle,
        date_from: date_from,
        //date_to: date_to,
        icon: icon,
        location: location,
        latitude: latitude,
        longitude: longitude,
      };
      onSessionAdd(session);
    } else if (mode === 'update' && selectedSession) {
      const updatedSession = {
        ...selectedSession,
        name: name,
        subtitle: subtitle,
        date_from: date_from,
        //date_to: date_to,
        icon: icon,
        location: location,
        latitude: latitude,
        longitude: longitude,
      };
      onSessionUpdate(updatedSession);
    }
    resetForm();
  };

  const handleSessionItemClick = (session) => {
    setMode('update');
    setSelectedSession(session);
    setName(session.name);
    setSubtitle(session.subtitle);
    setDateFrom(session.date_from);
    //setDateTo(session.date_to);
    setIcon(session.icon);
    setLocation(session.location);
    setLatitude(session.latitude);
    setLongitude(session.longitude);
  };

  const handleDeleteSession = () => {
    if (selectedSession) {
      onSessionDelete(selectedSession);
      resetForm();
    }
  };

  const resetForm = () => {
    setMode('create');
    setSelectedSession(null);
    setName('');
    setSubtitle('');
    setDateFrom('');
    //setDateTo('');
    setIcon(null);
    setLocation('');
    setLatitude(-33.442840627318205);
    setLongitude(-70.65470762839571);
  };

  const getMaterials = async (sessionId) => {
    
    const { data: materials, error: fetchError } = await supabase
      .from('materials')
      .select('*')
      .eq('session', sessionId);

    setMaterials(materials)
  
  }

  const getActivities = async (sessionId) => {
    
    const { data: activities, error: fetchError } = await supabase
      .from('activities')
      .select('*')
      .eq('session', sessionId);

    setActivities(activities)
  
  }

  useEffect(() => {
    if (selectedSession != null) {

      if (selectedSession.long) {
        marker.setLngLat([selectedSession.long, selectedSession.lat])
      }

      if (selectedSession.id){
        getMaterials(selectedSession.id)
        getActivities(selectedSession.id)
      }
    }

  }, [selectedSession])

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoiZWxtYXJjZWxvYyIsImEiOiJjbGk2aGJ1cG8wcTRvM2RwaGhpa3c2ZWY4In0.riGZsVcTiGjFap2FZalBWQ';
    const map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [longitude, latitude],
      zoom: 9,
    })

    setMap(map);

    const marker = new mapboxgl.Marker({
      draggable: true,
    })
      .setLngLat([longitude, latitude])
      .addTo(map);

    marker.on('dragend', () => {
      const lngLat = marker.getLngLat();
      setLongitude(lngLat.lng);
      setLatitude(lngLat.lat);
    });

    setMarker(marker)

    map.on('move', () => {
      const lngLat = map.getCenter();
      setLongitude(lngLat.lng);
      setLatitude(lngLat.lat);
    });

    return () => {
      map.remove();
      setMap(null)
    };
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item md={6}>
        <form onSubmit={handleSessionSubmit}>
          <Grid container spacing={2}>
            <Grid item md={12}>
              <TextField
                label="Nombre de la sesión"
                value={name}
                onChange={handleNameChange}
                required
                fullWidth
              />
            </Grid>
            <Grid item md={12}>
              <TextField
                label="Subtítulo"
                value={subtitle}
                onChange={handleSubtitleChange}
                required
                fullWidth
              />
            </Grid>
            <Grid item md={12}>
              <TextField
                value={date_from}
                onChange={handleDateFromChange}
                fullWidth
                type="date"
              />
            </Grid>
            {/* <Grid item md={12}>
              <TextField
                value={date_to}
                onChange={handleDateToChange}
                fullWidth
                type="date"
              /> 
            </Grid>*/}
            <Grid item md={12}>
            <FormControl fullWidth>
              <Grid container>
                <Grid item md={4}>
                  <InputLabel>Icono</InputLabel>
                  <Select
                    value={icon}
                    onChange={(e) => handleIconChange(e.target.value)}
                    required
                    fullWidth
                  >
                    {iconOptions.map((option) => (
                      <MenuItem key={option.label} value={option.label}>
                        {option.icon} {option.label.replace('Fa', '')}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item md={8}>
                  <TextField
                    value={icon}
                    onChange={(e) => setIcon(e.target.value)}
                    placeholder=' O usa un link'
                  />
                </Grid>
              </Grid>
            </FormControl>
            </Grid>
            <Grid item md={12}>
              <TextField
                label="Ubicación"
                value={location}
                onChange={handleLocationChange}
                required
                fullWidth
              />
            </Grid>
            <Grid item md={6}>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                {mode === 'create' ? 'Agregar Sesión' : 'Actualizar Sesión'}
              </Button>
            </Grid>
            <Grid item md={6}>
              <Button onClick={handleDeleteSession} variant="contained" color="error" fullWidth>
                Borrar Sesión
              </Button>
            </Grid>
            {mode === 'update' && (
              <Grid item md={12}>
                <Button onClick={resetForm} variant="contained" color="secondary" fullWidth>
                  Volver al modo "Crear Sesión"
                </Button>
              </Grid>
            )}
          </Grid>
        </form>
      </Grid>
      <Grid item md={6}>
        <Navbar title="Tu ruta" />
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {sessions.map((session, index) => (
            <SessionItem
              key={index}
              session={session}
              selected={session.id != null  && session.id === selectedSession?.id}
              isDemo={true}
              onClick={(e) => handleSessionItemClick(session)} />
          ))}
          <Divider light />
        </List>
      </Grid>
      <Grid item md={6}>
        <div id="map" style={{ width: '100%', height: '400px' }}></div>
      </Grid>
      <Grid item md={6}>
      {selectedSession?.id && (
        <>
          <Tabs value={selectedTab} onChange={handleTabChange}>
            <Tab value="materials" label="Materiales" />
            <Tab value="activities" label="Actividades" />
          </Tabs>
          {selectedTab === 'materials' && (
            <MaterialForm
              selectedSession={selectedSession}
              materials={materials}
              setMaterials={setMaterials}
            />
          )}
          {selectedTab === 'activities' && (
             <ActivitiesForm
               selectedSession={selectedSession}
               activities={activities}
               setActivities={setActivities}
             />
          )}
        </>
      )}
    </Grid>

    </Grid>
  );
};

export default SessionForm;
